
import React from 'react';
import 'antd/dist/antd.css';



import Footer from '../src/components/footer'
import MainRouter from './router'

import '../src/scss/app.scss'


function App() {
  return (
    <div className="App">
  
       <MainRouter></MainRouter>
       <Footer></Footer>
    </div>
  );
}

export default App;
